/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promos_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove promo" |
*
* @param {Promos_RemoveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_remove = /** @type {((inputs?: Promos_RemoveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_RemoveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer la promo")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar promo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remover promo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi promo")
	return /** @type {LocalizedString} */ ("Remove promo")
});